import { z } from "zod";
import moment from "moment";

import { Command } from "../../types";

export const exportTransactionsRequestSchema = z.object({
  command: z.literal(Command.ExportTransactions),

  dateRange: z.tuple([
    z.custom<moment.Moment>((value) => moment.isMoment(value), {
      message: "Invalid moment object",
    }),
    z.custom<moment.Moment>((value) => moment.isMoment(value), {
      message: "Invalid moment object",
    }),
  ]),
});

export type ExportTransactionsFormValues = z.infer<
  typeof exportTransactionsRequestSchema
>;
